<template>
    <el-card shadow="never" class="aui-card--fill">
        <div class="mod-dms__device">
            <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
                <el-form-item>
                    <el-input v-model="dataForm.mobileNumber" placeholder="会员手机号" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="dataForm.memberName" placeholder="会员姓名" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="dataForm.deviceCode" placeholder="设备码" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button @click="getDataList()">{{ $t('query') }}</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button v-if="$hasPermission('dms:device:save')" type="primary" @click="addOrUpdateHandle()">{{
                        $t('add') }}
                    </el-button>
                </el-form-item>
<!--                <el-form-item>-->
<!--                    <el-button v-if="$hasPermission('dms:device:delete')" type="danger" @click="deleteHandle()">{{-->
<!--                        $t('deleteBatch') }}-->
<!--                    </el-button>-->
<!--                </el-form-item>-->
            </el-form>
            <el-table v-loading="dataListLoading" :data="dataList" border
                      @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
                <!--        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>-->
                <!--        <el-table-column prop="id" label="ID" header-align="center" align="center"></el-table-column>-->
                <!--        <el-table-column prop="memberId" label="会员ID" header-align="center" align="center"></el-table-column>-->
                <el-table-column prop="orgName" label="公司名称" header-align="center" align="center"></el-table-column>
                <el-table-column prop="memberName" label="会员姓名" header-align="center" align="center"></el-table-column>
                <el-table-column prop="mobileNumber" label="会员电话号" header-align="center"
                                 align="center"></el-table-column>
                <el-table-column prop="deviceCode" label="设备码" header-align="center" align="center"></el-table-column>
                <el-table-column prop="autoDeductAgreement" label="是否签约产品售后" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.autoDeductAgreement===0" size="small" type="success">未签约</el-tag>
                        <el-tag v-if="scope.row.autoDeductAgreement===1" size="small" type="success">已签约</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="signDate" label="签约时间" header-align="center" align="center"></el-table-column>
                <el-table-column prop="dueDate" label="截止时间" header-align="center" align="center"></el-table-column>
<!--                <el-table-column prop="inlineTime" label="今日在线时长，小时" header-align="center"-->
<!--                                 align="center"></el-table-column>-->
                <el-table-column prop="expirationTime" label="到期时间" header-align="center"
                                 align="center"></el-table-column>
                <el-table-column prop="createDate" label="创建时间" header-align="center" align="center"></el-table-column>
                <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
                    <template slot-scope="scope">
                        <el-button v-if="$hasPermission('dms:device:update')" type="text" size="small"
                                   @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}
                        </el-button>
                        <el-button v-if="$hasPermission('dms:device:update')" type="text" size="small"
                                   @click="deleteDevice(scope.row.id)">解除绑定
                        </el-button>
                        <el-button v-if="$hasPermission('dms:device:update')" type="text" size="small"
                                   @click="changeDevice(scope.row.id)">更换设备
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    :current-page="page"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="limit"
                    :total="total"
                    layout="total, sizes, prev, pager, next, jumper"
                    @size-change="pageSizeChangeHandle"
                    @current-change="pageCurrentChangeHandle">
            </el-pagination>
            <!-- 弹窗, 新增 / 修改 -->
            <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
            <ChangeDevice  v-if="changeDeviceVisible" ref="ChangeDevice" @refreshDataList="getDataList"></ChangeDevice>
            <DeleteDevice v-if="deleteDeviceVisible" ref="DeleteDevice" @refreshDataList="getDataList"> </DeleteDevice>
        </div>
    </el-card>
</template>

<script>
    import mixinViewModule from '@/mixins/view-module'
    import AddOrUpdate from './device-add-or-update'
    import ChangeDevice from './device-change'
    import DeleteDevice from './device-delete'
    export default {
        mixins: [mixinViewModule],
        data() {
            return {
                mixinViewModuleOptions: {
                    getDataListURL: '/dms/device/page',
                    getDataListIsPage: true,
                    exportURL: '/dms/device/export',
                    deleteURL: '/dms/device',
                    deleteIsBatch: true
                },
                changeDeviceVisible:false,
                deleteDeviceVisible:false,
                dataForm: {
                    mobileNumber: '',
                    deviceCode: '',
                    memberName:''
                }
            }
        },
        methods: {
            changeDevice(id) {
                this.changeDeviceVisible = true
                this.$nextTick(() => {
                    this.$refs.ChangeDevice.init(id)
                })
            },
            deleteDevice(id) {
                this.deleteDeviceVisible = true
                this.$nextTick(() => {
                    this.$refs.DeleteDevice.init(id)
                })
            },
        },
        components: {
            AddOrUpdate,
            ChangeDevice,
            DeleteDevice
        }
    }
</script>
